import React from "react";

const PreLoginTabbar = ({ handleChangeTab, selectedTab }) => (
  <div className="container">
    <ul className="tab-list visible-xs">
      <li onClick={() => handleChangeTab("howItWorks")}>
        <a
          href="javascript: void(0)"
          className={(selectedTab === "howItWorks" && "active") || ""}
        >
          How it Works?
        </a>
      </li>
      <li onClick={() => handleChangeTab("loveLocal")}>
        <a
          href="javascript: void(0)"
          className={(selectedTab === "loveLocal" && "active") || ""}
        >
          Love Local
        </a>
      </li>
      <li onClick={() => handleChangeTab("joinUs")}>
        <a
          href="javascript: void(0)"
          className={(selectedTab === "joinUs" && "active") || ""}
        >
          Join Us
        </a>
      </li>
    </ul>
  </div>
);

export default PreLoginTabbar;
